import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { SE_FE_TRANSLATIONS_BASE_PATH, SE_FE_TRANSLATIONS_PREFIX } from 'se-fe-translations';

@Injectable()
export class SeFeTranslateLoader extends TranslateLoader {
  private readonly http = inject(HttpClient);
  private readonly basePath = inject<string>(SE_FE_TRANSLATIONS_BASE_PATH);
  private readonly prefix = inject<string>(SE_FE_TRANSLATIONS_PREFIX);

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(`${this.basePath}/${this.prefix}/${lang}.json`);
  }
}
